'use client'
import { Image } from '@heroui/image'
import { Skeleton } from '@heroui/skeleton'
import { useDisclosure } from '@heroui/use-disclosure'

import { GetImageArgs, useImage } from '@/data'
import { cn } from '@/utils'

import ImageModal from '../image-modal'

const IMAGE_SIZE = 54

interface EncryptedImageProps {
  thumbnail: GetImageArgs['image']
  original?: GetImageArgs['image']
  withPreview?: boolean
}

const EncryptedImage = ({
  original,
  thumbnail,
  withPreview = true,
}: EncryptedImageProps) => {
  const {
    data: thumbnailImage,
    isLoading: isThumbnailLoading,
    isError: isThumbnailError,
  } = useImage({ image: { path: thumbnail.path, type: thumbnail.type } })

  const { data: originalImage } = useImage({
    image: { path: original?.path ?? '', type: original?.type ?? '' },
    enabled: !!original && withPreview,
  })

  const { isOpen, onOpenChange } = useDisclosure()

  if (isThumbnailLoading)
    return <Skeleton className="h-[54px] w-[54px] rounded-2xl" />
  if (!thumbnailImage || isThumbnailError) return null

  return (
    <>
      <Image
        shadow="none"
        src={thumbnailImage.url}
        alt="moment-image"
        width={IMAGE_SIZE}
        height={IMAGE_SIZE}
        style={{ width: IMAGE_SIZE, height: IMAGE_SIZE }}
        classNames={{
          wrapper: cn('relative rounded-2xl cursor-pointer'),
          img: 'object-cover',
        }}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          if (withPreview) {
            onOpenChange()
          }
        }}
      />
      <ImageModal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        image={originalImage?.url ?? ''}
        aspectRatio={originalImage?.aspectRatio}
      />
    </>
  )
}

export default EncryptedImage
